var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSolvedRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1476 10.7978C14.9106 9.55369 15.5 8.50767 15.5 7.26087C15.5 4.31483 13.2217 2 10.5 2C7.77826 2 5.5 4.31483 5.5 7.26087C5.5 8.52062 6.10248 9.6726 6.86137 10.9594C6.9125 11.0461 6.96463 11.134 7.01731 11.2227C7.3352 11.7584 7.67326 12.3282 7.93649 12.889C8.1125 13.2639 8.27025 13.6648 8.37375 14.087H12.6053C12.8524 12.8997 13.4891 11.8665 14.0315 10.9865C14.0707 10.9228 14.1095 10.8599 14.1476 10.7978ZM13.5 15.087C13.5 13.7631 14.2008 12.622 14.9249 11.4429C15.6991 10.1824 16.5 8.87832 16.5 7.26087C16.5 3.80309 13.8137 1 10.5 1C7.18629 1 4.5 3.80309 4.5 7.26087C4.5 8.93847 5.36156 10.3913 6.16126 11.7398C6.85383 12.9077 7.5 13.9973 7.5 15.087H8.5H12.5H13.5Z",
    fill: "#EB0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50006 15.8696H13.5001V16.0001C13.5001 16.6063 13.5001 16.9094 13.4444 17.1604C13.2469 18.0512 12.5512 18.7469 11.6604 18.9444C11.4094 19.0001 11.1063 19.0001 10.5001 19.0001C9.89386 19.0001 9.59076 19.0001 9.33972 18.9444C8.44891 18.7469 7.7532 18.0512 7.55571 17.1604C7.50006 16.9094 7.50006 16.6063 7.50006 16.0001V15.8696Z",
    fill: "#EB0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSolvedRed);
export default __webpack_public_path__ + "static/media/icon_solved_red.2e57acdbb36b04a2c25c73196772e2b0.svg";
export { ForwardRef as ReactComponent };